import React from "react";

import taxAssistMockup from "../img/screen/tax-assist-functions.png";

const About = () => {
  return (
      <>
        <div id="apork-about-area" className="apork-about-area mt-230">
          <div className="container">
            <div className="row">
              <div className="col-xl-10 col-lg-10 mx-auto">
                <div className="section-title mb-80">
                  <h4 className="text-highlighter text-center">Simplify UK Taxes with UK Tax & Salary Assist</h4>
                  <p className="mt-3 text-center">
                    UK Tax & Salary Assist is your go-to solution for managing UK taxes. Whether you're employed, self-employed, or earning from multiple sources, our app helps you take control of your finances with ease.
                  </p>
                  <p className="mt-3 text-center">
                    From calculating take-home pay to simplifying self-assessment tax returns, our AI-powered app is here to make your tax management hassle-free and efficient.
                  </p>

                  <div className="mt-50 mb-50 center">
                    <img src={taxAssistMockup} alt="UK Tax Assist App Mockup" />
                  </div>

                  <h4 className="text-highlighter mt-3 text-center">What Our App Offers:</h4>
                  <ul className="mt-3">
                    <li>
                      <strong>Take-Home Pay Calculation:</strong> Input your salary, bonuses, or other income, and see how much you'll take home after taxes and National Insurance.
                    </li>
                    <li>
                      <strong>Multiple Income Management:</strong> Handle various income sources, including salaries, rental income, dividends, self-employment income, pensions, and more.
                    </li>
                    <li>
                      <strong>Self-Assessment Tax Support:</strong> Step-by-step guidance to simplify the self-assessment process, helping you stay on top of your tax obligations.
                    </li>
                    <li>
                      <strong>Scenario Planning:</strong> Explore how changes in your income or allowances affect your taxes and take-home pay, enabling smarter financial planning.
                    </li>
                    <li>
                      <strong>Financial Insights:</strong> Get clear breakdowns of your taxes, allowances, National Insurance contributions, and deductions to better understand your financial situation.
                    </li>
                  </ul>

                  <h4 className="text-highlighter mt-3 text-center">Why Choose Us?</h4>
                  <ul className="mt-3">
                    <li>
                      <strong>User-Friendly Design:</strong> Enter your income details in plain English without needing to understand complex tax jargon.
                    </li>
                    <li>
                      <strong>Comprehensive Coverage:</strong> Manage all aspects of your UK taxes in one app, from take-home pay to self-assessment returns.
                    </li>
                    <li>
                      <strong>Designed for You:</strong> Whether you're a professional, freelancer, landlord, or retiree, our app adapts to your unique financial situation.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default About;
